import { Form, Input, Typography } from "antd";
import Img from "assets/images";
import CustomModal from "components/CustomModal";
import { SELLER_ACCESS_STATUS } from "features/Agent/constants";
import { t } from "i18next";
import { noop } from "lodash";
import "./index.scss";

export const REASON_MAX_LENGTH = 500;

function AccessReasonModal({ visible, nextStatus, loading, onCancel, onOke }) {
  const [form] = Form.useForm();
  const modalKey = nextStatus === SELLER_ACCESS_STATUS.RESTRICTED ? "restrict_modal" : "allow_modal";

  // BE only checks min=1, so a whitespace-only reason is blocked here and the value is sent trimmed
  const handleOke = () => form.validateFields().then(({ reason }) => onOke(reason.trim()), noop);

  return (
    <CustomModal
      className="access-reason-modal"
      visible={visible}
      selfVisibleControlled={false}
      centered={true}
      footer={false}
      isBlockCloseOnOke
      icon={Img.LockedIcon}
      title={
        <Typography.Text strong className="access-reason-modal__title">
          {t(`v2.seller.access_status.${modalKey}.title`)}
        </Typography.Text>
      }
      subTitle={
        <Typography.Text className="access-reason-modal__description">
          {t(`v2.seller.access_status.${modalKey}.description`)}
        </Typography.Text>
      }
      buttonLoading={loading}
      onOke={handleOke}
      onCancel={onCancel}
      afterClose={() => form.resetFields()}
    >
      <Form form={form}>
        <Form.Item
          name="reason"
          rules={[{ required: true, whitespace: true, message: t("v2.seller.access_status.reason_required") }]}
        >
          <Input.TextArea
            rows={3}
            maxLength={REASON_MAX_LENGTH}
            showCount
            placeholder={t("v2.seller.access_status.reason_placeholder")}
          />
        </Form.Item>
      </Form>
    </CustomModal>
  );
}

export default AccessReasonModal;
